import { render, staticRenderFns } from "./UploadDocumentNew.vue?vue&type=template&id=95ebf4a6&scoped=true"
import script from "./UploadDocumentNew.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentNew.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentNew.vue?vue&type=style&index=0&id=95ebf4a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ebf4a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95ebf4a6')) {
      api.createRecord('95ebf4a6', component.options)
    } else {
      api.reload('95ebf4a6', component.options)
    }
    module.hot.accept("./UploadDocumentNew.vue?vue&type=template&id=95ebf4a6&scoped=true", function () {
      api.rerender('95ebf4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/UploadDocumentNew.vue"
export default component.exports